import { EventFormPage, EventsAdmin } from 'features/admin/Event'
import { LocationFormPage, LocationsAdmin } from 'features/admin/Location'
import { OrganizationsAdmin } from 'features/admin/Organization'
import { ShowFormPage, ShowsAdmin } from 'features/admin/Show'
// eslint-disable-next-line no-restricted-imports
import { ScanEventSelector } from 'features/admin/Ticket/ticketScan/scanEventSelector'
import { Login } from 'features/user/Login'
import { Logout } from 'features/user/Logout'
import { SignUp } from 'features/user/Signup'
import { CheckAuditoriumForEventPage } from 'pages/Admin/CheckAuditoriumForEventPage'
import { DownloadLocalTicketsPage } from 'pages/Admin/DownloadLocalTicketsPage'
import { LocalSellingCartPage } from 'pages/Admin/LocalSellingCartPage'
import { LocalTicketReleasePage } from 'pages/Admin/LocalTicketReleasePage'
import { LocalTicketSellingPage } from 'pages/Admin/LocalTicketSellingPage'
import { TicketScanPage } from 'pages/Admin/TicketScanPage'
import { EventListUserPage, LandingPage, ShowDetailsPage, ShowListUserPage, TicketBuyingPage } from 'pages/User'
import { CartPage } from 'pages/User/CartPage'
import { CustomerFormPage } from 'pages/User/CustomerFormPage'
import { DownloadTicketsPage } from 'pages/User/DownloadTicketsPage'
import { ErrorPage } from 'pages/User/ErrorPage'
import { Route, Routes } from 'react-router-dom'
import { ProtectedRouteOA, ProtectedRouteSA } from 'utils'
import { ProtectedRouteOASA } from 'utils/ProtectedRouteOASA'

export const routes = {
    LANDING: '/',
    ADMIN: '/admin',
    LOGIN: '/login',
    SIGNUP: '/signup',
    LOGOUT: '/kijelentkezes',
    CONTACT: '/kapcsolat',
    ORGANIZATIONS_ADMIN: '/admin/szervezetek',
    LOCATIONS_ADMIN: '/admin/helyszinek',
    LOCATION_FORM: '/admin/helyszinek/form/:id?',
    LOCATION_INDIVIDUAL_ORG: '/admin/helyszinek/szervezet/:partnerId?',
    SHOWS: '/musor',
    SHOWS_DETAILS: '/musor/:id',
    SHOWS_ADMIN: '/admin/musor',
    SHOWS_FORM: 'admin/musor/form/:id?',
    SHOWS_INDIVIDUAL_ORG: '/admin/musor/szervezet/:partnerId?',
    EVENTS: '/esemenyek',
    EVENT_ADMIN: '/admin/esemenyek',
    EVENT_FORM: '/admin/esemenyek/form/:id?',
    EVENT_INDIVIDUAL_ORG: '/admin/esemenyek/szervezet/:partnerId?',
    SELECT_EVENT_FOR_SCAN: '/admin/jegyellenorzes/esemenyvalasztas',
    TICKET_SCAN_CHECK_AUDITORIUM: '/admin/jegyellenorzes/telitettseg',
    TICKET_SCAN: '/admin/jegyellenorzes',
    BUYING_TICKET: '/jegyek/vasarlas/:eventId',
    CART: '/jegyek/kosar/:eventId',
    LOCAL_SELLING_CART_ADMIN: '/admin/jegyek/kosar/:eventId',
    TICKETS: '/jegyek/letoltes/:eventId',
    LOCAL_SELLING_TICKET_ADMIN: '/admin/jegyek/eladas/:id',
    LOCAL_RELEASE_TICKET_ADMIN: '/admin/jegyek/felszabaditas/:id',
    LOCALLY_SOLD_TICKETS: 'admin/jegyek/letoltes/helyi/:eventId',
    CUSTOMER_DATA: '/jegyek/vasarlo/:eventId',
    ERROR: '/hiba/404',
}

export const AppRoutes = () => {
    return (
        <Routes>
            <Route index element={<LandingPage />} />
            <Route path={routes.LOGIN} element={<Login />} />
            <Route path={routes.LANDING} element={<ProtectedRouteSA />}>
                <Route path={routes.SIGNUP} element={<SignUp />} />
                <Route path={routes.ORGANIZATIONS_ADMIN} element={<OrganizationsAdmin />} />
                <Route path={routes.LOCATION_INDIVIDUAL_ORG} element={<LocationsAdmin />} />
                <Route path={routes.SHOWS_INDIVIDUAL_ORG} element={<ShowsAdmin />} />
                <Route path={routes.EVENT_INDIVIDUAL_ORG} element={<EventsAdmin />} />
            </Route>
            <Route path={routes.LANDING} element={<ProtectedRouteOA />}>
                <Route path={routes.SELECT_EVENT_FOR_SCAN} element={<ScanEventSelector />} />
                <Route path={routes.TICKET_SCAN_CHECK_AUDITORIUM} element={<CheckAuditoriumForEventPage />} />
                <Route path={routes.TICKET_SCAN} element={<TicketScanPage />} />
                <Route path={routes.ADMIN} element={<ErrorPage />} />
                <Route path={routes.LOCAL_SELLING_TICKET_ADMIN} element={<LocalTicketSellingPage />} />
                <Route path={routes.LOCAL_SELLING_CART_ADMIN} element={<LocalSellingCartPage />} />
                <Route path={routes.LOCAL_RELEASE_TICKET_ADMIN} element={<LocalTicketReleasePage />} />
                <Route path={routes.LOCALLY_SOLD_TICKETS} element={<DownloadLocalTicketsPage />} />
                <Route path="*" element={<ErrorPage />} />
            </Route>
            <Route path={routes.LANDING} element={<ProtectedRouteOASA />}>
                <Route path={routes.EVENT_FORM} element={<EventFormPage />} />
                <Route path={routes.LOCATION_FORM} element={<LocationFormPage />} />
                <Route path={routes.SHOWS_FORM} element={<ShowFormPage />} />
                <Route path={routes.SHOWS_ADMIN} element={<ShowsAdmin />} />
                <Route path={routes.EVENT_ADMIN} element={<EventsAdmin />} />
                <Route path={routes.LOCATIONS_ADMIN} element={<LocationsAdmin />} />
                <Route path={routes.ERROR} element={<ErrorPage />} />
            </Route>
            <Route path={routes.CUSTOMER_DATA} element={<CustomerFormPage />} />
            <Route path={routes.BUYING_TICKET} element={<TicketBuyingPage />} />
            <Route path={routes.CART} element={<CartPage />} />
            <Route path={routes.TICKETS} element={<DownloadTicketsPage />} />
            <Route path={routes.SHOWS} element={<ShowListUserPage />} />
            <Route path={routes.SHOWS_DETAILS} element={<ShowDetailsPage />} />
            <Route path={routes.EVENTS} element={<EventListUserPage />} />
            <Route path={routes.CONTACT} element={<LandingPage />} />
            <Route path={routes.LOGOUT} element={<Logout />} />
        </Routes>
    )
}
